import Emkt from '../../emkt'

export default {
  methods: {
    saveCartManually () {
      const cartJsonString = JSON.stringify(this.cartList.cartContent)
            // $.showPreloader('正在添加商品')
      this.$weui.loading('正在添加商品')
      if (Emkt.isWappGuest) { // 小程序游客模式根据openID获取数据
        this.gcapi('saveWappGuestShoppingCart', {
          openId: this.customerOpenId,
          cartContent: cartJsonString
        }).then((response) => {
                    // $.hidePreloader()
          this.$weui.loading().hide()
          if (response.body.code === 0) {
            this.$weui.toast('添加成功', 1500)
                    // $.toast('添加成功')
            console.log('手动保存购物车成功：save Shopping cart successfully')
          } else {
            this.$weui.topTips('添加失败', 1000)
                    // $.showPreloader('添加失败')
                    // setTimeout(function () {
                    //   $.hidePreloader()
                    // }, 1000)
          }
        })
      } else {
        this.gcapi('saveShoppingCart', cartJsonString).then((response) => {
                    // $.hidePreloader()
          this.$weui.loading().hide()
          if (response.body.code === 0) {
            this.$weui.toast('添加成功', 1500)
                    // $.toast('添加成功')
            console.log('手动保存购物车成功：save Shopping cart successfully')
          } else {
            this.$weui.topTips('添加失败', 1000)
                    // $.showPreloader('添加失败')
                    // setTimeout(function () {
                    //   $.hidePreloader()
                    // }, 1000)
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views_v_2.6/PrivateMixins/MerchandisesMixin.js